import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import AgregarSubsidioPaso1 from "./AgregarPaso1";
import AgregarSubsidioPaso2a from "./AgregarPaso2Reposo";
import AgregarSubsidioPaso2b from "./AgregarPaso2Nacimiento";
import AgregarSubsidioPaso2c from "./AgregarPaso2Conyuge";
import AgregarSubsidioPaso3 from "./AgregarPaso3";
import AgregarSubsidioPaso4 from "./AgregarPaso4";
import AgregarSubsidioPaso5 from "./AgregarPaso5";

export default class AgregarSubsidio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Datos Paso 1
      datosCuenta: undefined,
      nroCedula: undefined,
      tipoSubsidio: undefined,
      claseSubsidio: undefined,
      tipoDescripcion: undefined,
      claseDescripcion: undefined,
      cantDiasMin: 0,
      cantDiasMax: 0,
      fechaHecho: undefined,
      montoARecibir: 0,
      // Datos Paso Reposo
      cantDiasSubsidio: undefined,
      diagnostico: undefined,
      nroHospital: undefined,
      hospitalDescripcion:undefined,
      nroMedico: undefined,
      medicoDescripcion: undefined,
      nroEnfermedad: undefined,
      enfermedadDescripcion: undefined,
      // Datos Paso Recien Nacido
      primerNombreRn: undefined,
      segundoNombreRn: undefined,
      primerApellidoRn: undefined,
      segundoApellidoRn: undefined,
      sexoRn: undefined,
      fechaNacimientoRn: undefined,
      nacionalidadRn: undefined,
      nacRnDescripcion: undefined,
      libro: undefined,
      folio: undefined,
      acta: undefined,
      // Datos Paso Conyuge
      primerNombreCon: undefined,
      segundoNombreCon: undefined,
      primerApellidoCon: undefined,
      segundoApellidoCon: undefined,
      sexoCon: undefined,
      fechaNacimientoCon: undefined,
      nacionalidadCon: undefined,
      nacDescripcionCon: undefined,
      respuestaServ: undefined,
      // Datos Archivos
      fileCedula: undefined,
      fileCertificado: undefined,
      fileAnalisis: undefined,
      fileAdopcion: undefined,
    };
  }

  componentDidMount() {
   
  }
  respuestaPaso1 = (datosCuenta, nroCedula, nroCuenta, nroTipoSub, nroClaseSubsidio, tipoDescripcion, claseDescripcion, fechaHecho, cantDiasMax, cantDiasMin, montoARecibir) => {
    this.setState({
      datosCuenta: datosCuenta,
      nroCedula: nroCedula,
      idAhorro: nroCuenta,
      tipoSubsidio: nroTipoSub,
      claseSubsidio: nroClaseSubsidio,
      tipoDescripcion: tipoDescripcion,
      claseDescripcion: claseDescripcion,
      cantDiasMax: cantDiasMax,
      cantDiasMin: cantDiasMin,
      fechaHecho: fechaHecho,
      montoARecibir: (nroClaseSubsidio === 210 || nroTipoSub === 4) ? montoARecibir : undefined
    }, () => console.log(
      console.log(this.state)
    ));

  };
 
  // Paso Diagnostico Medico
  respuestaPaso2 = (cantDias, diagnostico, nroHospital, hospitalDescripcion, nroMedico, medicoDescripcion, nroEnfermedad, enfermedadDescripcion, montoARecibir) => {
    this.setState( {
      cantDiasSubsidio: cantDias,
      diagnostico: diagnostico,
      nroHospital: nroHospital,
      hospitalDescripcion:hospitalDescripcion,
      nroMedico: nroMedico,
      medicoDescripcion: medicoDescripcion,
      nroEnfermedad: nroEnfermedad,
      enfermedadDescripcion: enfermedadDescripcion,
      montoARecibir: (montoARecibir) ? montoARecibir : this.state.montoARecibir
    }, () => {
      console.log(this.state.montoARecibir)
    });
  };

  // Paso Recien Nacido
  respuestaPaso2b = (primerNombre, segundoNombre, primerApellido, segundoApellido, sexo, fechaNac,nroNacionalidad, nacDescripcion, libro, folio, acta) => {
    this.setState({
      primerNombreRn: primerNombre,
      segundoNombreRn: segundoNombre,
      primerApellidoRn: primerApellido,
      segundoApellidoRn: segundoApellido,
      sexoRn: sexo,
      fechaNacimientoRn: fechaNac,
      nacionalidadRn: nroNacionalidad,
      nacRnDescripcion: nacDescripcion,
      libro: libro,
      folio: folio,
      acta: acta,
    });
  };

    // Paso Conyuge
    respuestaPaso2c = (primerNombre, segundoNombre, primerApellido, segundoApellido, cedula, fechaNac, nroNacionalidad, nacDescripcion) => {
      this.setState({
        primerNombreCon: primerNombre,
        segundoNombreCon: segundoNombre,
        primerApellidoCon: primerApellido,
        segundoApellidoCon: segundoApellido,
        cedulaCon: cedula,
        fechaNacimientoCon: fechaNac,
        nacionalidadCon: nroNacionalidad,
        nacDescripcionCon: nacDescripcion
      }, () => {
        console.log(this.state.nacionalidadCon)
      });
    };

    respuestaServ = (dato) => {
      this.setState({
        respuestaServ: dato,
      }, () => {});
    }

    respuestaPaso3 = (CI1, CI2, premio1, premio2, repNacimiento, repAdopcion, repDomicilio1, repDomicilio2, repDomicilio3, repDomicilio4, repDomicilio5, estudiosLab1, estudiosLab2, estudiosLab3, estudiosLab4, estudiosLab5, repInternacion1, repInternacion2, repInternacion3) => {
      if (this.state.tipoSubsidio === 4) {
        this.setState({
          fileCedula: [CI1, CI2].filter(Boolean),
          fileCertificado: [premio1, premio2].filter(Boolean),
          fileAdopcion: undefined,
          fileAnalisis: undefined
        }, () => (
          console.log(this.state.fileCedula, this.state.fileCertificado)
          ))
        return;
      }

      if (this.state.claseSubsidio === 210) {
        this.setState({
          fileCedula: [CI1, CI2].filter(Boolean),
          fileCertificado: [repNacimiento],
          fileAdopcion: [repAdopcion],
          fileAnalisis: undefined
        }, () => (
          console.log(this.state.fileCedula, this.state.fileCertificado, this.state.fileAd)
        ))
        return;
      }

      if (this.state.claseSubsidio === 7 && this.state.cantDiasSubsidio < 7) {
        this.setState({
          fileCedula: [CI1, CI2].filter(Boolean),
          fileCertificado: [repDomicilio1, repDomicilio2, repDomicilio3, repDomicilio4, repDomicilio5].filter(Boolean),
          fileAdopcion: undefined,
          fileAnalisis: undefined
        }, () => (
          console.log(this.state.fileCedula, this.state.fileCertificado)
        ))
        return;
      }

      if (this.state.claseSubsidio === 7 && this.state.cantDiasSubsidio >= 7) {
        this.setState({
          fileCedula: [CI1, CI2].filter(Boolean),
          fileCertificado: [repDomicilio1, repDomicilio2, repDomicilio3, repDomicilio4, repDomicilio5].filter(Boolean),
          fileAnalisis: [estudiosLab1, estudiosLab2, estudiosLab3, estudiosLab4, estudiosLab5].filter(Boolean),
          fileAdopcion: undefined,
        }, () => (
          console.log(this.state.fileCedula, this.state.fileCertificado, this.state.fileAnalisis)
        ))
        return;
      }

      if (this.state.claseSubsidio === 8) {
        this.setState({
          fileCedula: [CI1, CI2].filter(Boolean),
          fileCertificado: [repInternacion1, repInternacion2, repInternacion3].filter(Boolean),
          fileAdopcion: undefined,
          fileAnalisis: undefined
        }, () => (
          console.log(this.state.fileCedula, this.state.fileCertificado)
        ))
        return;
      }
    }

 
  render() {
      return (
        <div className="content-wrapper">
          <Titulo texto="Agregar Subsidios"/>
          <section className="content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                          <StepWizard transitions='none'>
                              <AgregarSubsidioPaso1 respuestaPaso1={this.respuestaPaso1.bind(this)}/>
                              <AgregarSubsidioPaso2a respuestasData={this.state} respuestaPaso2={this.respuestaPaso2}/>
                              <AgregarSubsidioPaso2b respuestasData={this.state} respuestaPaso2b={this.respuestaPaso2b.bind(this)}/>
                              <AgregarSubsidioPaso2c respuestasData={this.state} respuestaPaso2c={this.respuestaPaso2c} />
                              <AgregarSubsidioPaso3 respuestasData={this.state} respuestaPaso3={this.respuestaPaso3}/>
                              <AgregarSubsidioPaso4 respuestasData={this.state} respuestaServ={this.respuestaServ}/>
                              <AgregarSubsidioPaso5 respuestasData={this.state}/>
                          </StepWizard> 
                     </div>    
                  </div>                    
                </div> 
              </div>
            </div>           
          </section> 
        </div>
     
      );
  }
}